<template>
    <div class="animated fadeIn">
        <eire-index-mark-form v-if="showIndexMarkForm" v-bind:eireIndexMark="indexMarkObj" v-bind:mode="indexMarkInputMode"></eire-index-mark-form>
        <div v-if="!showIndexMarkForm" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <h1>Eire Index Mark Management</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Eire Index Mark List</strong>
                        </div>
                        <div v-if="!indexMarksLoaded" class="form-container">
                            <LoadingSpinner />
                        </div>
                        <div v-if="indexMarksLoaded" class="form-container">
                            <b-row v-if="!isUserReadOnly">
                                <b-col cols="12" sm="12" md="6">
                                    <p>
                                        <b-button v-on:click="enterAddMode" variant="primary">
                                            <i class="fa fa-plus"></i>&nbsp;Add Eire Index Mark
                                        </b-button>
                                    </p>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="tableFilter">Filter</label>
                                        <b-form-input v-model="tableFilter" type="text" id="tableFilter"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12">
                                    <div>
                                        <b-table
                                            id="data-table"
                                            class="datalist-table"
                                            selectable
                                            hover
                                            bordered
                                            select-mode="single"
                                            :items="indexMarks"
                                            :fields="tableFields"
                                            :filter="tableFilter"
                                            :per-page="perPage"
                                            :current-page="tableCurrentPage"
                                            @row-clicked="indexMarkRowSelected"
                                            responsive="sm"
                                            >
                                        </b-table>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6" class="my-1">
                                    <b-pagination
                                    v-model="tableCurrentPage"
                                    :total-rows="tableTotalRows"
                                    :per-page="tablePerPage"
                                    class="my-0"
                                    ></b-pagination>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>

import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import cTable from '../../components/table/Table';
import EireIndexMarkForm from '../../components/forms/eire-index-marks/EireIndexMarkForm.vue';


export default {
  name: 'EireIndexMarks',
  components: {
      LoadingSpinner: LoadingSpinner,
      cTable,
      EireIndexMarkForm
  },
  data () {
    return {
        userAuthLevel: '',
        newEireIndexMark: this.resetEireIndexMark(),
        addMode: false,
        editMode: false,
        indexMarksLoaded: false,
        tableFilter: '',
        perPage: 20,
        tablePerPage: 20,
        tableCurrentPage: 1,
        tableTotalRows: 0,
        tableFields: [
            {key: 'code', label: 'Code', sortable: true},
            {key: 'county', label: 'County', sortable: true},
            {key: 'irish_name', label: 'Irish Name', sortable: true}
        ],
        indexMarks: [],
        indexMarkInputMode: 'add',
        indexMarkObj: {},
        showIndexMarkForm: false
    }
  },
  created () {
    this.getIndexMarks();
  },
  watch: {
  },
  computed: {
    isUserReadOnly() {
        console.log(this.$data.userAuthLevel);
        if (this.$data.userAuthLevel == 'Read Only') {
            return true;
        }
        else {
            return false;
        }
    },
  },
  methods : {
    closeEireIndexMarkForm() {
        this.getIndexMarks();
        this.$data.showIndexMarkForm = false;
        this.$data.addMode = false;
        this.$data.editMode = false;
    },
    resetEireIndexMark() {
        return {
            id: 0,
            code: '',
            county: '',
            irish_name: '',
            local_authority: ''
        }
    },
    getCurrentUser () {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user != null) {
                resolve(user);
            }
            else {
                reject();
            }
        });
    },
    indexMarkRowSelected(item, index) {
        let user = JSON.parse(localStorage.getItem('user'));
        if(user === null) {
          return;
        }
        if(typeof  user.auth === 'undefined'){
          return;
        }
        // grab the index mark. We already have the data in the array
        let indexMark = this.$data.indexMarks.filter((indexMarkObj) => {
            return indexMarkObj.id == item.id;
        })[0];
        console.log(indexMark);
        this.$data.indexMarkObj = indexMark;
        this.enterEditMode();

    },
    getHTTPHeaders() {
      let userObj = JSON.parse(localStorage.getItem('user'));
      return {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + userObj.token,
          }
        };
    },
    getIndexMarks() {
        this.getCurrentUser()
            .then((userDetails) => {
                this.$data.userAuthLevel = userDetails.auth;
                let headersObj = this.getHTTPHeaders();
                return this.$http.get("eireindexmarks", headersObj)
            })
            .then((response) => {
                console.log(response);
                this.$data.indexMarks = response.data.index_marks;
                this.$data.tableTotalRows = response.data.index_marks.length;
                this.$data.indexMarksLoaded = true;
            })
            .catch ((err) => {
                console.error(err);
            });
    },
    enterAddMode() {
        this.$data.indexMarkObj = this.resetEireIndexMark();
        this.$data.showIndexMarkForm = true;
        this.$data.editMode = false;
        this.$data.addMode = true;
        this.$data.indexMarkInputMode = 'add';
    },
    enterEditMode() {
        this.$data.showIndexMarkForm = true;
        this.$data.addMode = false;
        this.$data.editMode = true;
        this.$data.indexMarkInputMode = 'edit';
    },
  }
}
</script>
